<div class="detail-pane-parent" [hidden]="navigation.$target() !== null">
@if ($showEmpty()) {
  <div class="detail-pane-state">
    <i class="fa-regular fa-file-lines"></i>
    <span>No document selected</span>
  </div>
} @else if ($showLoading()) {
  <div class="detail-pane-state">
    <i class="fa fa-spinner fa-spin"></i>
    <span>Loading document…</span>
  </div>
} @else if ($showError()) {
  <div class="detail-pane-state">
    <i class="fa-regular fa-triangle-exclamation"></i>
    <span>The document could not be loaded</span>
  </div>
} @else if ($surfaceDefinition(); as definition) {
  <wb-surface [definition]="definition" />
}
</div>
<!-- No Back row here: Back is published through DETAIL_PANE_BACK so the child
     surface's header renders it leftmost on the title row. -->
@if (navigation.$target(); as target) {
  <div class="detail-pane-child" animate.enter="detail-pane-slide-in" animate.leave="detail-pane-slide-out">
    <detail-pane #childPane [context]="target.context" />
  </div>
}
